import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import '../../human-resources/scss/change-rate.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import moDistribution, {
  timeTabChange,
} from './store/index';
import Empty from '@comp/empty/index';
import { newRateABS } from '@tool/index';
import moEffect from '../../store/index';
import moMenu from '../../store/menu';

interface IProps { }
interface IState { }

const DistributionRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    empty, timeActive, list, maxValue, totalValue,
    declineCount, declineRate, increaseCount, increaseRate,
  } = moDistribution;
  const { yearList } = moEffect;

  useEffect(() => {
    return () => { };
  }, []);

  const newValue = (value: any, digit: number = 0) => {
    let newValue = 0;
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) newValue = 0;
    if (value === null || value === '' || value === undefined) newValue = 0;
    newValue = round(Math.abs(value) * 100, digit);
    if (newValue > 50) newValue = 50;
    return newValue;
  };

  // 第二个参数 - 保留几位小数
  const downRate = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    let newValue = round(Math.abs(value) * 100, digit);
    if (newValue <= 1) newValue = 1;
    return `${newValue}%`;
  };

  return (
    <section id="effect13" className="human-common change-rate-warp">
      <SubTitle title="变化率分布" subtitle={moMenu.industryName} active={''}
        bg={Color.primaryColor(0.1)} color={Color.primary} />

      <section className="content-05010 content-05011">
        <section className="content-05015 content-05017">
          {!isEmpty(list) ? (
            <>
              <section className="box-001">
                <b className='left-001'>
                  {round(declineRate * 100, 0)}%
                </b>
                <b className='right-001'>
                  {round(increaseRate * 100, 0)}%
                </b>
                <p className="line-001">
                  <b>{declineCount}家企业人员规模下降</b>
                  <b>{increaseCount}家企业人员规模增长</b>
                </p>
                <p className="line-002">
                  <b style={{
                    width: `${declineCount * 100 / totalValue}%`,
                  }} />
                  <span style={{
                    width: `${(totalValue - declineCount - increaseCount) * 100 / totalValue}%`,
                  }}>
                    <i />
                  </span>
                  <strong style={{
                    width: `${increaseCount * 100 / totalValue}%`,
                  }} />
                </p>
              </section>
              <section className="box-002">
                <section className="section-01 section-03">
                  {list.map((item: any, index: number) => (
                    <p key={index}
                      className={[
                        'item-002',
                        index > 2 ? 'up-002' : '',
                        index < 2 ? 'down-002' : '',
                        index === 2 ? 'stable-002' : '',
                      ].join(' ')}>
                      <b>{item.count}{item.count !== 0 ? '家' : ''}</b>
                      <strong style={{
                        height: `${((item.count / maxValue) * 100)}px`,
                      }} />
                    </p>
                  ))}
                </section>
                <p className="section-01 section-02">
                  {list.map((item: any, index: number) => (
                    <span key={index}>{item.label}</span>
                  ))}
                </p>
              </section>
            </>
          ) : (
            <Empty />
          )}
        </section>
      </section>

      <TimeTab list={yearList} active={timeActive} onChange={timeTabChange} />
    </section>
  );
};

export default observer(DistributionRate);
